<template>
  <div class="job-resourcing-form">
    <div class="container">
      <div class="job-article">
        <h5>Sign Up To Future Jobs</h5>
        <p class="tagline">Tell us what you’re looking for and we’ll match you to future jobs as they come up to find you the right job.</p>

        <div v-if="submitted">
          <h6>Thank you for signing up</h6>
          <p>We will keep your details and as new jobs become available we will get in touch.</p>
        </div>
        <div v-else>


          <div class="errors" v-if="errors.length > 0">
            <p class="error-message">{{errors[0]}}</p>
          </div>

          <div class="row">
            <div class="col-md-4">
              <label>
                <i class="fas fa-user"></i>
                Full name <strong>*</strong>
              </label>
              <input type="text" v-model="fullName" />
            </div>
            <div class="col-md-4">
              <label>
                <i class="fas fa-envelope"></i>
                Email <strong>*</strong>
              </label>
              <input type="text" v-model="email" />
            </div>
            <div class="col-md-4">
              <label>
                <i class="fas fa-phone-alt"></i>
                Phone <strong>*</strong>
              </label>
              <input type="text" v-model="phone" />
            </div>
          </div>

          <hr />

          <div class="row">
            <div class="col-md-4">
              <label>
                <i class="fas fa-hammer"></i>
                Job Title <strong>*</strong>
              </label>
              <multiselect v-model="jobTitle" id="title" name="title" placeholder=""
                           :multiple=false :options="jobTitleOptions" label="job_title" track-by="job_title"></multiselect>
            </div>
            <div class="col-md-4">
              <label>
                <i class="fas fa-map-marker-alt"></i>
                Location <strong>*</strong>
              </label>
              <input type="text" v-model="location" />
            </div>
            <div class="col-md-4">
              <label>
                <i class="fas fa-bullseye"></i>
                Radius <strong>*</strong>
              </label>
              <input type="text" v-model="radius" />
            </div>
          </div>

          <div class="row">
            <div class="col-md-4">
              <label>
                <i class="fas fa-address-card"></i>
                CSCS Card <em>(optional)</em>
              </label>
              <input type="text" v-model="cscsCard" />
            </div>
            <div class="col-md-4">
              <label>
                <i class="fas fa-coins"></i>
                Rate Preferred <em>(optional)</em>
              </label>
              <input type="text" v-model="rate" />
            </div>
            <div class="col-md-4">
              <label>
                <i class="fas fa-calendar"></i>
                Date Available From <em>(optional)</em>
              </label>
              <datepicker v-model="dateAvailable"></datepicker>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <label>
                <input type="checkbox" v-model="hasOwnTransport" /> <em>I have my own transport</em>
              </label>
            </div>
            <div class="col-md-9">
              <label>
                <input type="checkbox" v-model="hasEmployerReference" /> <em>I can provide previous employer references</em>
              </label>
            </div>
          </div>

          <p class="text-center">
            <button class="btn btngenius-client-login mt-0" @click="submitResourceRequest()">Sign Up</button>
          </p>

        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Resource from "../../../js/2021/classes/models/resources/Resource";
import Datepicker from 'vuejs-datepicker';
import moment from "moment-mini";
import Multiselect from 'vue-multiselect';



export default {
  name: "jobResourcingForm",
  components: {Datepicker, Multiselect},
  data() {
    return {
      crmENVurl: process.env.MIX_API_MICRO_URL,
      loading: false,
      submitted: false,

      fullName: '',
      email: '',
      phone: '',
      jobTitle: '',
      location: '',
      radius: '',
      cscsCard: '',
      rate: '',
      dateAvailable: new Date(),
      hasOwnTransport: false,
      hasEmployerReference: false,

      jobTitleOptions: [],

      errors: [],
    }
  },
  created() {
    axios.get('orca/worker/job_titles').then(response => {
      this.jobTitleOptions = response.data;
    });
  },
  methods: {
    submitResourceRequest() {

      this.errors = [];

      if(this.fullName === null || this.fullName === '') {
        this.errors.push('Tell us your full name');
      }
      if(this.email === null || this.email === '') {
        this.errors.push('Tell us your email');
      }
      if(this.phone === null || this.phone === '') {
        this.errors.push('Tell us your phone');
      }
      if(this.jobTitle === null || this.jobTitle === '') {
        this.errors.push('Tell us your job title');
      }
      if(this.location === null || this.location === '') {
        this.errors.push('Tell us your location');
      }
      if(this.radius === null || this.radius === '') {
        this.errors.push('Tell us your radius');
      } if(!this.isNumeric(this.radius)) {
        this.errors.push('Please enter a radius which is numerical');
      }

      // Optional Fields
      if(this.rate !== null && this.rate.length > 0) {
        if(!this.isNumeric(this.rate)) {
          this.errors.push('Please enter a rate which is numerical');
        }
      }

      if(this.errors.length > 0) {
        return;
      }

      this.loading = true;

      let firstName = this.fullName;
      let lastName = '';

      if(this.fullName.split(" ").length-1 > 0) {
        firstName = this.fullName.substring(0, this.fullName.indexOf(' '));
        lastName = this.fullName.substring(this.fullName.indexOf(' ') + 1);
      }

      axios.post('orca/worker/resources_sign_up', {
        'first_name': firstName,
        'surname': lastName,
        'email': this.email,
        'phone': this.phone,
        'job_title': this.jobTitle.job_title,
        'location': this.location,
        'radius': this.radius,
        'cscs_card': this.cscsCard,
        'rate': this.rate,
        'date_available': moment(this.dateAvailable).format('YYYY-MM-DD'),
        'has_own_transport':  this.hasOwnTransport,
        'has_employer_reference': this.hasEmployerReference,
      }).then(response => {

        let resource = new Resource(response.data);
        this.loading = false;

        if(resource.id > 0) {
          this.submitted = true;
        }
      });

      console.log('No errors');

    },
    isNumeric(n) {
      return !isNaN(n);
    }
  }
}
</script>
<style type="text/css">
.job-resourcing-form {
  margin-top: 30px;
}

.job-resourcing-form .job-article {
  overflow: visible;
}

.job-resourcing-form h5 {
  color: #e3097e;
  font-size: 40px;
  text-align: center;
}

.job-resourcing-form p.tagline {
  text-align: center;
  margin-bottom: 50px;
}

.job-resourcing-form .col-md-3, .job-resourcing-form .col-md-4, .job-resourcing-form .col-md-9 {
    padding-left: 15px;
    padding-right: 15px;
  }

.job-resourcing-form input {
  color: black;
  display: inline-block;
  margin-bottom: 30px;
}

.job-resourcing-form input[type=checkbox] {
  margin: 0;
  width: 30px;
  height: 30px;
  vertical-align: middle;
}

.job-resourcing-form label {
  font-size: 13px;
  font-weight: bold;
  color: black;
}

.job-resourcing-form label i {
  color: #e3097e;
  font-size: 16px;
}

.job-resourcing-form label strong {
  color: red;
}
.job-resourcing-form label em {
  font-style: italic;
  font-weight: normal;
}

.job-resourcing-form p.error-message {
  padding: 5px;
  margin-bottom: 20px;
  color: white;
  background-color: red;
}

</style>
